<template>
  <div class="project-management-layout bg-gray-50">
    <SideBar height-class="h-full" />

    <!-- Main Content -->
    <main
      class="project-management-work-area p-6"
    >
      <h1 class="text-2xl font-bold text-gray-700">
        Project Management
      </h1>
      <ProjectList />
    </main>
  </div>
</template>

<script>
import SideBar from '@/ReusableComponents/SideBar.vue'
import ProjectList from '../ProjectManagementComponents/ProjectList.vue'

export default {
  name: 'ProjectManagement',
  components: { ProjectList, SideBar },
  setup() {
    return {}
  }
}
</script>

<style scoped>
.project-management-layout {
  display: flex;
  flex: 1 1 auto;
  min-width: 0;
  min-height: 0;
  overflow: hidden;
}

.project-management-work-area {
  flex: 1 1 auto;
  min-width: 0;
  min-height: 0;
  overflow-y: auto;
  overscroll-behavior: contain;
  -webkit-overflow-scrolling: touch;
}
</style>
